module.exports = __webpack_public_path__ + "static/img/1.155b183.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Empresariales-Seguro-Colectivo/1.png
// module id = Hwae
// module chunks = 0